import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=45ba9efe&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=45ba9efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba9efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ba9efe')) {
      api.createRecord('45ba9efe', component.options)
    } else {
      api.reload('45ba9efe', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=45ba9efe&scoped=true&", function () {
      api.rerender('45ba9efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dKmpTAbjqL3l/JS/comp/Voucher.vue"
export default component.exports